/* HoneMD treatment PDP controller (v2): gallery + lightbox + FAQ + sticky bar.
   FAQ text is server-rendered expanded (SEO/no-JS); JS collapses on load.
   Lightbox: prev/next through all media, Esc/backdrop/X close, focus trapped and
   returned, swipe on touch, native pinch-zoom allowed, reduced-motion safe. */
(function () {
  function watchHeader() {
    var sticky = document.querySelector('sticky-header');
    var headerSection = sticky ? sticky.closest('.shopify-section') : null;
    var header = document.querySelector('.header-wrapper');
    if (!headerSection || !header) return;
    function update() {
      var hidden = headerSection.classList.contains('shopify-section-header-hidden');
      var h = Math.round(hidden ? 0 : header.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--hm-header-offset', h + 'px');
    }
    new MutationObserver(update).observe(headerSection, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function watchPreviewBar() {
    function measure() {
      var bar = document.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe, iframe[src*="preview_bar"]');
      var h = 0;
      if (bar) {
        var r = bar.getBoundingClientRect();
        if (r.height > 0 && r.height < 160 && r.bottom >= window.innerHeight - 4) h = Math.round(r.height);
      }
      document.documentElement.style.setProperty('--hm-preview-offset', h + 'px');
    }
    measure();
    setTimeout(measure, 1200);
    setTimeout(measure, 3000);
    window.addEventListener('resize', measure, { passive: true });
  }

  function init(root) {
    if (root.dataset.hmPdpBound) return;
    root.dataset.hmPdpBound = '1';

    /* gallery carousel: native scroll-snap = touch flick; pointer-drag for mouse;
       prev/next arrows; thumbnails sync both ways. A real drag suppresses the
       slide click so it doesn't open the lightbox. */
    var track = root.querySelector('[data-hm-pdp-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.hm-pdp__thumb[data-hm-pdp-idx]'));
    if (track) {
      var slideCount = track.children.length;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var slideW = function () { return Math.max(1, track.clientWidth); };
      var curIndex = function () { return Math.round(track.scrollLeft / slideW()); };
      /* Manual rAF glide writing scrollLeft directly: UA smooth scrollTo gets
         cancelled on this snap container in Chromium, but direct writes always
         land (the drag handler relies on the same primitive). Snap is suspended
         during the glide and re-engages exactly on the target snap point. */
      var animId = null;
      var watchdog = null;
      var glideEnd = null;
      var stopGlide = function (jumpToEnd) {
        if (animId) { window.cancelAnimationFrame(animId); animId = null; }
        if (watchdog) { clearTimeout(watchdog); watchdog = null; }
        if (jumpToEnd && glideEnd !== null) track.scrollLeft = glideEnd;
        glideEnd = null;
        track.classList.remove('is-gliding');
      };
      var goTo = function (i) {
        i = Math.max(0, Math.min(slideCount - 1, i));
        stopGlide(false);
        var start = track.scrollLeft;
        var end = i * slideW();
        var dist = end - start;
        if (reduceMotion || Math.abs(dist) < 2) { track.scrollLeft = end; return; }
        track.classList.add('is-gliding');
        glideEnd = end;
        var t0 = null;
        var DUR = 360;
        var step = function (ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / DUR);
          var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
          track.scrollLeft = start + dist * e;
          if (p < 1) { animId = window.requestAnimationFrame(step); }
          else { stopGlide(false); }
        };
        animId = window.requestAnimationFrame(step);
        /* rAF freezes in hidden/occluded or battery-throttled tabs - if the
           glide hasn't finished shortly after its duration, land instantly. */
        watchdog = setTimeout(function () { stopGlide(true); }, DUR + 150);
      };
      track.addEventListener('touchstart', function () { stopGlide(false); }, { passive: true });
      var prevBtn = root.querySelector('[data-hm-pdp-prev]');
      var nextBtn = root.querySelector('[data-hm-pdp-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(curIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(curIndex() + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.dataset.hmPdpIdx, 10) || 0); });
      });
      var syncTimer = null;
      track.addEventListener('scroll', function () {
        if (syncTimer) return;
        syncTimer = setTimeout(function () {
          syncTimer = null;
          var i = curIndex();
          thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
        }, 80);
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(curIndex() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(curIndex() + 1); }
      });
      /* page-level arrow keys drive the gallery too (owner ask, 2026-08-27) -
         but never while typing in a field and never while the lightbox is open
         (the lightbox owns its own arrow handling). */
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        if (e.defaultPrevented) return;
        var t = e.target;
        if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return;
        var lbEl = document.querySelector('[data-hm-pdp-lightbox]');
        if (lbEl && !lbEl.hidden) return;
        if (e.key === 'ArrowLeft') { goTo(curIndex() - 1); } else { goTo(curIndex() + 1); }
      });
      /* mouse drag (touch uses the native scroll container) */
      var dragging = false, dragMoved = false, dragStartX = 0, dragStartLeft = 0, dragStartIdx = 0, suppressClick = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        stopGlide(false);
        dragging = true; dragMoved = false;
        dragStartX = e.clientX; dragStartLeft = track.scrollLeft; dragStartIdx = curIndex();
        track.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - dragStartX;
        if (Math.abs(dx) > 6) dragMoved = true;
        track.scrollLeft = dragStartLeft - dx;
      });
      window.addEventListener('pointerup', function (e) {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        if (dragMoved) {
          var dx = e.clientX - dragStartX;
          if (dx < -50) goTo(dragStartIdx + 1);
          else if (dx > 50) goTo(dragStartIdx - 1);
          else goTo(dragStartIdx);
          suppressClick = true;
          setTimeout(function () { suppressClick = false; }, 80);
        }
      });
      track.addEventListener('click', function (e) {
        if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    }

    /* lightbox */
    var lb = root.querySelector('[data-hm-pdp-lightbox]');
    if (lb) {
      var media = (lb.dataset.media || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      var img = lb.querySelector('[data-hm-pdp-lb-img]');
      var idx = 0;
      var lastFocus = null;
      function show(i) {
        idx = (i + media.length) % media.length;
        img.src = media[idx];
      }
      function open(i) {
        if (!media.length) return;
        lastFocus = document.activeElement;
        lb.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        show(i);
        lb.querySelector('[data-hm-pdp-lb-close]:not(.hm-pdp__lb-backdrop)').focus();
      }
      function close() {
        lb.hidden = true;
        document.documentElement.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }
      Array.prototype.forEach.call(root.querySelectorAll('[data-hm-pdp-open]'), function (btn) {
        btn.addEventListener('click', function () { open(parseInt(btn.dataset.hmPdpOpen, 10) || 0); });
      });
      Array.prototype.forEach.call(lb.querySelectorAll('[data-hm-pdp-lb-close]'), function (b) {
        b.addEventListener('click', close);
      });
      lb.querySelector('[data-hm-pdp-lb-prev]').addEventListener('click', function () { show(idx - 1); });
      lb.querySelector('[data-hm-pdp-lb-next]').addEventListener('click', function () { show(idx + 1); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key === 'ArrowLeft') { show(idx - 1); return; }
        if (e.key === 'ArrowRight') { show(idx + 1); return; }
        if (e.key === 'Tab') {
          var f = lb.querySelectorAll('button:not([tabindex="-1"])');
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
      var touchX = null;
      lb.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 48) show(dx > 0 ? idx - 1 : idx + 1);
        touchX = null;
      }, { passive: true });
    }

    /* FAQ: collapse all on load, then toggle */
    Array.prototype.forEach.call(root.querySelectorAll('[data-hm-pdp-faq-q]'), function (q) {
      var a = q.parentElement.querySelector('[data-hm-pdp-faq-a]');
      if (!a) return;
      q.setAttribute('aria-expanded', 'false');
      a.hidden = true;
      q.addEventListener('click', function () {
        var open = q.getAttribute('aria-expanded') === 'true';
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
        a.hidden = open;
      });
    });

    /* sticky bar */
    var bar = root.querySelector('[data-hm-pdp-bar]');
    var hero = root.querySelector('[data-hm-pdp-hero]');
    var footer = document.querySelector('.footer');
    if (bar && hero) {
      var update = function () {
        bar.hidden = hero.getBoundingClientRect().bottom > 0;
        if (footer) bar.classList.toggle('is-yielded', footer.getBoundingClientRect().top < window.innerHeight);
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(update, { threshold: 0 }).observe(hero);
        if (footer) new IntersectionObserver(update, { threshold: 0 }).observe(footer);
      }
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; update(); });
      }, { passive: true });
      update();
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-hm-pdp]').forEach(init);
  }
  function start() {
    watchHeader();
    watchPreviewBar();
    boot();
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* Rate-card tier toggle (2026-08-28). One delegated handler; the three rates
   are precomputed in Liquid and carried on the container's data attributes, so
   switching tiers never recalculates or refetches. */
(function () {
  document.addEventListener('click', function (e) {
    var tab = e.target.closest ? e.target.closest('.hm-rate__tab') : null;
    if (!tab) return;
    var card = tab.closest('[data-hm-rate]');
    if (!card) return;
    var tier = tab.getAttribute('data-tier');
    var value = card.getAttribute('data-' + (tier === 'new' ? 'new' : tier));
    if (!value) return;
    card.querySelectorAll('.hm-rate__tab').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    var out = card.querySelector('[data-hm-rate-now]');
    if (out) out.textContent = value;
  });
})();
